// extracted by mini-css-extract-plugin
export default {"modal":"notimodal_modal__EA0m9","modalContent":"notimodal_modalContent__9lY7A"};